import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
import { Text } from 'foundations-components/components/Text';
import { Section } from 'foundations-components/transitional/components/Section';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { PRODUCT_BUILDER_GATE } from 'products-ui-components/constants/permissions';
import { usePermissionsContext } from '../contexts/PermissionsContext';
import { useProductData } from '../contexts/ProductDataContext';
import { useProductProperties } from '../contexts/ProductPropertiesContext';
import { PriceSection } from './header/PriceSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductHighlightHeader = () => {
  const productProperties = useProductProperties();
  const product = useProductData();
  const {
    hasGate
  } = usePermissionsContext();
  if (!product || !productProperties) {
    return null;
  }
  const isUserUngatedForProductEditor = hasGate(PRODUCT_BUILDER_GATE);
  const productName = getProperty(product, 'name');
  const productStatus = getProperty(product, 'hs_status');
  const productSku = getProperty(product, 'hs_sku');
  const skuProperty = productProperties.get('hs_sku');
  return /*#__PURE__*/_jsxs(Section, {
    "data-selenium-test": "universal-sidebar-highlight",
    children: [isUserUngatedForProductEditor && /*#__PURE__*/_jsx(Section, {
      "data-test-id": "product-status",
      paddingInlineStart: "500",
      marginBlockEnd: "200",
      children: productStatus === 'inactive' ? /*#__PURE__*/_jsx(StatusTag, {
        "data-test-id": "product-status-inactive",
        use: "removed",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "inactive"
        })
      }) : /*#__PURE__*/_jsx(StatusTag, {
        "data-test-id": "product-status-active",
        use: "active",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "active"
        })
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      paddingInlineStart: "500",
      children: productName
    }), productSku && /*#__PURE__*/_jsx(Section, {
      "data-test-id": "product-sku",
      paddingInlineStart: "500",
      marginBlockStart: "300",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsxs(Text, {
        children: [skuProperty === null || skuProperty === void 0 ? void 0 : skuProperty.label, ": ", productSku]
      })
    }), /*#__PURE__*/_jsx(PriceSection, {})]
  });
};
export default /*#__PURE__*/memo(ProductHighlightHeader);